import { useWeb3React } from '@web3-react/core';
import { InjectedConnector } from '@web3-react/injected-connector';
import useBalance from './useBalance';
import useBlockNumber from './useBlockNumber';
import {useEffect} from 'react';
import {useCurrentUserContext} from 'features/user/contexts/user-provider';
import $t from 'translation';

const useWeb3 = () => {
  const { active, account, activate, library, error } = useWeb3React();
  const balance = useBalance();
  const blockNumber = useBlockNumber();
  const { authorized, guest } = useCurrentUserContext();
  
  useEffect (() => {
    if( authorized || guest ) {
      connect();
    }
  }, [ authorized, guest]);
  
  const connect = async () => {
    await activate(new InjectedConnector({}));
  };
  
  const getErrorMessage = () => {
    if(error) {
      switch (error.code) {
        case -32002:
          return $t('web3.connect.error');
          
        default:
          return $t('web3.metamask.connect.error');
      }
    } else {
      return null;
    }
  };
  
  return {
    active,
    account,
    library,
    balance,
    blockNumber,
    errorMessage: getErrorMessage(),
  };
};

export default useWeb3;